import { createPinia } from "pinia";

export const pinia = createPinia();

export const initializeStoreSync = () => {
  if (typeof window === "undefined") return;

  // Initialize state from localStorage
  if (localStorage.getItem("pinia")) {
    try {
      const storedState = JSON.parse(localStorage.getItem("pinia"));
      // Update individual store states instead of replacing pinia.state.value
      Object.keys(storedState).forEach((storeId) => {
        if (pinia.state.value[storeId]) {
          Object.assign(pinia.state.value[storeId], storedState[storeId]);
        } else {
          pinia.state.value[storeId] = storedState[storeId];
        }
      });
    } catch (e) {}
  }

  // ! Watch for store changes
  watch(
    pinia.state,
    (newState, oldState) => {
      const serializedState = JSON.stringify(newState);
      localStorage.setItem("pinia", serializedState);
    },
    { deep: true, immediate: true }
  );

  // ! Listen for storage events from other BROWSER tabs
  window.addEventListener("storage", (event) => {
    if (event.key === "pinia" && event.newValue) {
      try {
        const newState = JSON.parse(event.newValue);
        // Replace state entirely instead of merging
        pinia.state.value = newState;
        console.log("State updated from storage event:", newState);
      } catch (e) {
        console.error("Failed to parse storage event data:", e);
      }
    }
  });
};
